import { createContext, useContext, useState } from "react";

type DriversStep = "invite" | undefined;

interface DriversState {
  step: DriversStep;
  setStep: React.Dispatch<React.SetStateAction<DriversStep>>;
}

const DriversContext = createContext<DriversState | null>(null);

export const DriversContextProvider = ({ children }: React.PropsWithChildren) => {
  const [step, setStep] = useState<DriversStep>();

  return (
    <DriversContext.Provider value={{ step, setStep }}>
      {children}
    </DriversContext.Provider>
  );
};

export const useDriversContext = () => {
  const context = useContext(DriversContext);
  if (!context) throw new Error("useDriversContext must be used within a DriversContextProvider");

  return context;
};